import { createFileRoute } from '@tanstack/react-router';
import { Container, Typography, Paper, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from '@tanstack/react-router';
import StructuredAuditList from '@/components/structured-audits/StructuredAuditList';

export const Route = createFileRoute('/preparer/audit-logs')({
  component: AuditLogsPage,
});

function AuditLogsPage() {
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component={RouterLink} to="/preparer" color="inherit">
          Preparer Dashboard
        </Link>
        <Typography color="text.primary">Audit Logs</Typography>
      </Breadcrumbs>

      {/* Page Header */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          System Audit Logs
        </Typography>
        <Typography variant="body1" color="text.secondary">
          View and search all system audit activity including client management, document uploads, organizer changes,
          and user actions.
        </Typography>
      </Paper>

      {/* Audit List */}
      <Paper sx={{ p: 2 }}>
        <StructuredAuditList height="calc(100vh - 300px)" showFilters={false} pageSize={25} />
      </Paper>
    </Container>
  );
}
